/**
 * DialogActions - Action buttons section for dialogs.
 *
 * Container for dialog action buttons (e.g., Cancel, Submit).
 */

import { type ReactNode } from 'react';
import { cn } from '@lean-agility/design-system/react';

export interface DialogActionsProps {
  /**
   * Action buttons.
   */
  children: ReactNode;
  /**
   * Additional CSS classes.
   */
  className?: string;
}

export function DialogActions({ children, className }: DialogActionsProps) {
  return <div className={cn('flex items-center justify-end gap-2 pt-2', className)}>{children}</div>;
}
